import { getSeconds } from './getSeconds';

/**
 * Get the number of seconds elapsed from a start time and end time, rounded to one decimal place
 *
 * @param {number} startTime start time in milliseconds
 * @param {number} endTime end time in milliseconds
 * @returns {number} the seconds elapsed, rounded to one decimal place
 */
export const getSecondsElapsed = (startTime: number, endTime: number) =>
  getSeconds(endTime - startTime);
